module.exports = {"business_name":"Business name","enter_business_name":"Enter business name","select_business_category":"Select business category","specify_further":"Specify further","fixed_location":"Will you mainly use iZettle at a fixed location?","seasonal_business":"Do you have a seasonal business?","select_turnover":"Select turnover with iZettle","select_average_transaction":"Select average transaction size","estimate_per_year":"Estimate per year"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/company.json
// module id = 633
// module chunks = 247 1461